module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_3009.fd645b07.png";